import styled from 'styled-components';

export const StyledTableWrapper = styled.div`
    .ant-table-container,
    .ant-table-content {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        overflow: hidden;
    }

    .anticon {
        color: var(--gray-6);
    }

    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
        color: var(--brand-7);
    }

    .row-align-top > td,
    .declaration-table-row > td {
        vertical-align: top !important;
    }

    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background-color: var(--brand-6);
    }

    .ant-table-thead > th.ant-table-column-sort {
        background-color: saddlebrown !important;
    }

    .ant-pagination {
        /* Previous button - disabled state */
        .ant-pagination-prev.ant-pagination-disabled {
            .ant-pagination-item-link {
                background-color: var(--gray-3) !important;
                border-color: var(--gray-5) !important;
                color: var(--gray-6) !important;

                .anticon {
                    color: var(--gray-6) !important;
                }
            }
        }

        .ant-pagination-item:hover {
            border-color: var(--brand-7);
            background-color: var(--brand-1);

            & > a {
                color: var(--brand-7);
            }
        }

        /* Previous button - enabled state */
        .ant-pagination-prev:not(.ant-pagination-disabled) {
            .ant-pagination-item-link {
                color: var(--brand-6) !important;
                border-color: var(--brand-6) !important;

                .anticon {
                    color: var(--brand-6) !important;
                }

                &:hover {
                    color: var(--brand-7) !important;
                    border-color: var(--brand-7) !important;
                    background-color: var(--brand-1) !important;

                    .anticon {
                        color: var(--brand-7) !important;
                    }
                }
            }
        }

        /* Next button - disabled state */
        .ant-pagination-next.ant-pagination-disabled {
            .ant-pagination-item-link {
                background-color: var(--gray-3) !important;
                border-color: var(--gray-5) !important;
                color: var(--gray-6) !important;

                .anticon {
                    color: var(--gray-6) !important;
                }
            }
        }

        /* Next button - enabled state */
        .ant-pagination-next:not(.ant-pagination-disabled) {
            .ant-pagination-item-link {
                color: var(--brand-6) !important;
                border-color: var(--brand-6) !important;

                .anticon {
                    color: var(--brand-6) !important;
                }

                &:hover {
                    color: var(--brand-7) !important;
                    border-color: var(--brand-7) !important;
                    background-color: var(--brand-1) !important;

                    .anticon {
                        color: var(--brand-7) !important;
                    }
                }
            }
        }

        /* Active page item */
        .ant-pagination-item-active {
            border-color: var(--brand-6);
            font-weight: 600;
            border-radius: 2px;
            background-color: var(--gray-1);

            & > a {
                color: var(--brand-6) !important;
            }
        }
    }
    .ant-checkbox-inner {
        border-color: var(--gray-5) !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: var(--brand-6) !important; /* Checked state */
        border-color: var(--brand-6) !important;
    }

    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
        background-color: var(--gray-3) !important; /* Disabled + Checked */
        border-color: var(--gray-5) !important;
        opacity: 1 !important; /* prevent it from looking faded */
    }

    .ant-checkbox-disabled .ant-checkbox-inner {
        background-color: var(--gray-3) !important; /* Disabled + Unchecked */
        border-color: var(--gray-4) !important;
    }

    .ant-table-tbody > tr.ant-table-row-selected > td {
        background-color: transparent !important;
    }

    /* An open group is tinted along with the rows it holds, so the group reads as one block. */
    .ant-table-tbody > tr.ics2-group-child-row > td,
    .ant-table-tbody > tr.ics2-group-child-row.ant-table-row-selected > td,
    .ant-table-tbody > tr.ics2-group-row-expanded > td {
        background-color: var(--gray-2) !important;
    }

    .ant-table-tbody > tr.ics2-group-child-row:hover > td,
    .ant-table-tbody > tr.ics2-group-row-expanded:hover > td {
        background-color: var(--gray-3) !important;
    }

    &.no-last-row-border .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }
`;

type StyledTableHeaderCellProps = {
    $hideDividers?: boolean;
};

export const StyledTableHeaderCell = styled.th<StyledTableHeaderCellProps>`
    && {
        font-weight: 600;
        background-color: rgba(233, 230, 245, 0.5);
        color: var(--brand-9);

        /* Remove the vertical lines separating the columns inside the header */
        ${({ $hideDividers = true }) =>
            $hideDividers &&
            `
        border-right: none !important;

        &::before {
          display: none !important;
          content: none !important;
          width: 0 !important;
          background: transparent !important;
        }
      `}
    }
`;
